module.exports = __webpack_public_path__ + "img/snowy_rocks_small.cf080a58.png";